export default __webpack_public_path__ + "static/media/BowlbyOne-Regular.1a76a38c.ttf";